import * as moment from "moment";

export class ItemOption {
    label: string = '';
    value: string | number = '';
}

export const addMonthDuration = (date: Date, value: string | number): Date => {
    return moment(date).add(value, 'months').toDate();
}


export const durationOptions: ItemOption[] = [
    { label: '', value: '' },
    {
        label: '1ヶ月',
        value: 1
    },
    {
        label: '3ヶ月',
        value: 3
    },
    {
        label: '半年',
        value: 6
    },
    {
        label: '1年',
        value: 12
    },

]